<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
	export default {
		name: 'App',
		created() {
			sessionStorage.setItem('fristUrl',window.location.href)	
		}
	}
</script>
